import * as Sentry from '@sentry/nextjs';
import Crypto from 'crypto';

import { errors } from '@/features/dashboard/localization';

import { ALGORITHM, LOCAL } from '@/constants/core';

const randomString = (length:number, string:boolean = false):string => {
  const chars = string ? 'abcdefghijklmnopqrstuvwxyz' : '0123456789abcdefghijklmnopqrstuvwxyz';
  let data = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    data += chars[randomIndex];
  }

  return data;
};
export const decrypt = async (data: string, tag: string): Promise<string | string> => {
  try {
    if (data && tag) {
      const key = Buffer.from(process.env.NEXT_PUBLIC_CRYPTO_SECRET_KEY!, 'base64');
      const iv = Buffer.from(process.env.NEXT_PUBLIC_CRYPTO_SECRET_IV!, 'base64');

      const decipher = Crypto.createDecipheriv(ALGORITHM, key, iv);

      const authTag = Buffer.from(tag, 'base64');
      decipher.setAuthTag(authTag);
      const encryptedData = Buffer.from(data, 'base64');
      let decrypted = decipher.update(encryptedData);
      decrypted = Buffer.concat([decrypted, decipher.final()]);
      return decrypted.toString('utf8');
    }
    return errors.tryAgain;
  } catch (error: any) {
    return errors.tryAgain;
  }
};

export const exception = async (message: any, info: { route: string, method: string, req: any }): Promise<void> => {
  // eslint-disable-next-line no-console
  console.log('message', message);
  // eslint-disable-next-line no-console
  console.log('info', info);
  if (process.env.NEXT_PUBLIC_APP_ENV !== LOCAL && message !== null) {
    // eslint-disable-next-line no-console
    Sentry.captureException(message);
    await Sentry.flush(2000);
  }
};

export const moneyFormat = (amount: string | number) => {
  const data = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount));

  return data;
};

export const checkNumber = (value: number): boolean => {
  if (value && typeof value === 'number' && value !== undefined && !Number.isNaN(value) && value > 0) return true;
  return false;
};

export const extractNumberOfFakeUuid = (value: string): number => {
  return parseInt(value.split('-')[0].replace(/[^0-9]/g, ''), 10);
};

export const fakeUuid = (value: string): string => {
  const data = `${value}${randomString(8 - value.length, true)}-${randomString(4)}-4${randomString(3)}-y${randomString(3)}-${randomString(12)}`;
  return data;
};

export const checkUserId = (userId: number): boolean => {
  if (userId && typeof userId === 'number' && userId !== undefined && !Number.isNaN(userId) && userId > 0) return true;
  return false;
};

export const formatUnits = (unit: string) => {
  switch (unit) {
    case 'days':
      return 'Días';
    case 'hours':
      return 'Horas';
    case 'minutes':
      return 'Minutos';
    default:
      return '';
  }
};

export const resendEmailVerification = async (): Promise<boolean> => {
  try {
    const request = await fetch('/api/resend-email-verification', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const response = await request.json();
    if (response.ok) return true;
    return false;
  } catch (error) {
    return false;
  }
};

export const getDatGames = async (games: string[], type: string) => {
  // const favoritesParam = games.length > 0 ? `favorites=${games.join(',')}` : '';

  try {
    const res = await fetch('/api/casino/games', {
      method: 'POST',
      body: JSON.stringify({ favorites: games, type }),
      cache: 'force-cache',
      next: { revalidate: 60 },
    });
    const game = await res.json();
    return game;
  } catch (error) {
    return [];
  }
};

export const getDataGamesTournaments = async (games: string[], type: string, provider: string) => {
  // const favoritesParam = games.length > 0 ? `favorites=${games.join(',')}` : '';

  try {
    const res = await fetch('/api/casino/games', {
      method: 'POST',
      body: JSON.stringify({ favorites: games, type, provider }),
      cache: 'force-cache',
      next: { revalidate: 60 },
    });
    const game = await res.json();
    return game;
  } catch (error) {
    return [];
  }
};

export const validateEmail = (email: string) => {
  const blockedEmails = process.env.NEXT_PUBLIC_BLOCKED_EMAILS?.split(',') || [];
  const emailDomain = email.split('@')[1].split('.')[0];
  return blockedEmails.includes(emailDomain);
};
